import React, { useEffect, useState } from 'react'
import { EditPage } from '@equipedigitalfloripa/ed-cms/components'
import * as SliderApi from '../api/slider'
import { useSelector } from 'react-redux'

const EditSlider = ({ edit }) => {
  const translations = useSelector(state => state.translations.translations)


  const selectedData = [
    {
      name: '_id',
      type: 'hidden',
      title: 'Id'
    },
    {
      name: 'nome',
      type: 'text',
      title: "Nome do slider",
      validation: {
        required: true
      },
      options: {
        maxLength: '150'
      },
    },
    {
      name: 'texto_apoio',
      type: 'text',
      title: "Texto que aparece no slider.",
    },
    {
      name: 'ordem',
      type: 'text',
      title: "Ordem que o slider aparece.",
    },
    {
      name: 'image',
      type: 'dragdrop',
      title: 'Imagem',
      options: {
        maxFiles: 1
      },
      validation: {
        required: true
      },
    },
  ]
  return (
    <EditPage
      title={edit ? "Editar Slider" : "Adicionar Slider"}
      subtitle={edit ? "Alterando informações do Slider" : "Adicionando informações do Slider"}
      selectedData={selectedData}
      addFunction={SliderApi.addItem}
      fetchFunction={SliderApi.fetchItem}
      editFunction={SliderApi.editItem}
      uploadFunction={SliderApi.uploadSlider}
      edit={edit}
      url='sliders'
    />
  )
}

export default EditSlider
